import { Globals } from "../CoreApp/Globals";

export function SVG_GetUniqueID(baseCode) {
  var id = Globals._svgUID++;
  var idStr = baseCode + id;

  return idStr;
}
